(function () {
  var pageSelector = '[data-yt-article-page]';

  function slugify(text) {
    return String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
  }

  function getScrollTop() {
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper && wrapper.scrollHeight > wrapper.clientHeight) return wrapper.scrollTop;
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function getScrollHeight() {
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper && wrapper.scrollHeight > wrapper.clientHeight) {
      return wrapper.scrollHeight - wrapper.clientHeight;
    }
    return document.documentElement.scrollHeight - window.innerHeight;
  }

  function initToc(root) {
    var toc = root.querySelector('[data-yt-article-toc]');
    var content = root.querySelector('[data-yt-article-content]');
    if (!toc || !content) return;

    var includeH3 = toc.dataset.includeH3 === 'true';
    var selector = includeH3 ? 'h2, h3' : 'h2';
    var headings = Array.from(content.querySelectorAll(selector)).filter(function (heading) {
      return heading.textContent.trim().length > 0;
    });
    var h2Count = headings.filter(function (heading) {
      return heading.tagName.toLowerCase() === 'h2';
    }).length;
    var minHeadings = Number(toc.dataset.minHeadings || 3);

    if (h2Count < minHeadings) {
      toc.hidden = true;
      root.classList.remove('yt-article-page--has-toc');
      return;
    }

    var used = {};
    headings.forEach(function (heading) {
      if (!heading.id) {
        var base = slugify(heading.textContent);
        var slug = base;
        var index = 2;
        while (document.getElementById(slug) || used[slug]) {
          slug = base + '-' + index;
          index += 1;
        }
        heading.id = slug;
      }
      used[heading.id] = true;
    });

    function buildList(list) {
      if (!list) return;
      list.innerHTML = '';
      headings.forEach(function (heading) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        link.dataset.tocTarget = heading.id;
        if (heading.tagName.toLowerCase() === 'h3') item.className = 'yt-article-toc__child';
        item.appendChild(link);
        list.appendChild(item);
      });
    }

    buildList(toc.querySelector('[data-yt-toc-list]'));
    buildList(toc.querySelector('[data-yt-toc-list-mobile]'));
    toc.hidden = false;
    root.classList.add('yt-article-page--has-toc');

    if ('IntersectionObserver' in window) {
      var links = Array.from(toc.querySelectorAll('[data-toc-target]'));
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (link) {
            var active = link.dataset.tocTarget === entry.target.id;
            link.classList.toggle('is-active', active);
            if (active) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        });
      }, {
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0.01
      });
      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }
  }

  function initShare(root) {
    root.querySelectorAll('[data-yt-copy-link]').forEach(function (button) {
      button.addEventListener('click', function () {
        var share = button.closest('[data-yt-article-share]');
        var status = share ? share.querySelector('[data-yt-copy-status]') : null;
        var label = button.querySelector('[data-yt-copy-label]');
        var url = button.dataset.shareUrl || window.location.href;

        function success() {
          if (label) label.textContent = 'Link copied';
          if (status) status.textContent = 'Link copied';
          window.setTimeout(function () {
            if (label) label.textContent = 'Copy Link';
            if (status) status.textContent = '';
          }, 2200);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(success).catch(function () {
            window.prompt('Copy this link', url);
          });
        } else {
          window.prompt('Copy this link', url);
          success();
        }
      });
    });

    root.querySelectorAll('[data-yt-native-share]').forEach(function (button) {
      if (!navigator.share) {
        button.hidden = true;
        return;
      }
      button.addEventListener('click', function () {
        navigator.share({
          title: button.dataset.shareTitle || document.title,
          url: button.dataset.shareUrl || window.location.href
        }).catch(function () {});
      });
    });
  }

  function initProgress(root) {
    var progress = root.querySelector('[data-yt-reading-progress]');
    var bar = root.querySelector('[data-yt-reading-progress-bar]');
    var content = root.querySelector('[data-yt-article-content]');
    if (!progress || !bar || !content || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var wordCount = (content.textContent || '').trim().split(/\s+/).filter(Boolean).length;
    if (wordCount < 280) return;

    var ticking = false;
    var update = function () {
      var max = getScrollHeight();
      var value = max > 0 ? Math.min(1, Math.max(0, getScrollTop() / max)) : 0;
      bar.style.transform = 'scaleX(' + value + ')';
      ticking = false;
    };
    var requestUpdate = function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };

    progress.hidden = false;
    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    document.addEventListener('scroll', requestUpdate, { passive: true });
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  }

  function initArticlePage(root) {
    initToc(root);
    initShare(root);
    initProgress(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(pageSelector).forEach(initArticlePage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
